import ContentfulCategory from "models/data/contentful/ContentfulCategory";

class ContentfulToApiCategory {
  static map = (contentfulCategory) => {
    return {
      id: ContentfulCategory.id(contentfulCategory),
      name: ContentfulCategory.categoryName(contentfulCategory),
      slug: ContentfulCategory.slug(contentfulCategory),
      descriptionHtml: ContentfulCategory.descriptionHtml(contentfulCategory),
      longDescriptionHtml:
        ContentfulCategory.longDescriptionHtml(contentfulCategory),
      title: ContentfulCategory.title(contentfulCategory),
      metaDescription: ContentfulCategory.metaDescription(contentfulCategory)
    };
  };
}

export default ContentfulToApiCategory;
